import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { ErrorCircleIcon, WarningCircleIcon } from '@app-velocity/icons';
import { Tooltip } from '@app-velocity/ui';

import { CompareSummaryWarning } from '../../types';

export type SummaryFooterProps = {
  action: ReactNode;
  warnings: CompareSummaryWarning[];
};

const Footer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  background: '#f9f9f9',
}));

const Warnings = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexShrink: 0,
}));

const FooterAction = styled('div')({
  marginLeft: 'auto',
});

const WarningIcon = styled('span')<{ warningType: 'error' | 'warning' }>(
  ({ theme, warningType }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    svg: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      fill:
        warningType === 'error'
          ? 'var(--error-error-icon-primary-color)'
          : 'var(--warning-warning-icon-primary-color)',
    },
  })
);

export const SummaryFooter = ({ action, warnings }: SummaryFooterProps) => {
  return (
    <Footer>
      {warnings.length ? (
        <Warnings>
          {warnings.map((warning) => (
            <Tooltip
              key={`${warning.type}-${warning.message}`}
              title={warning.message}
            >
              <WarningIcon
                warningType={warning.type}
                aria-label={warning.message}
              >
                {warning.type === 'error' ? (
                  <ErrorCircleIcon />
                ) : (
                  <WarningCircleIcon />
                )}
              </WarningIcon>
            </Tooltip>
          ))}
        </Warnings>
      ) : null}
      <FooterAction>{action}</FooterAction>
    </Footer>
  );
};
